import {Injectable} from "@angular/core";
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {Observable, of} from "rxjs";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {ContactNotificationSettingsDto, FilterDto, NotificationListDto, Orders} from "@server-models";
import {map} from "rxjs/operators";
import {ILocalPagination} from "@shared/interfaces/pagination.interface";
import {IRequestOptions} from "@shared/interfaces/request-options.interface";
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";

@Injectable({
  providedIn: 'root',
})
export class SharedNotificationsApiService extends CoreHttpClientApiBaseService {

  private emptyPagination: ILocalPagination = {
    pageSize: CoreEnvironmentService.getEnvironment()?.apiUrl?.pageDefaultSize ?? 50,
    pageNumber: 1,
    totalItems: 0,
    totalPages: 1
  }

  getNotifications(filters: FilterDto[] = [],
                   pagination: ILocalPagination = this.emptyPagination): Observable<ILocalPageOutputDto<NotificationListDto[]>> {

    // Prepare query
    const options: IRequestOptions = {
      params: {
        PageNumber: pagination.pageNumber.toString(),
        PageSize: pagination.pageSize.toString(),
        SortField: 'occuredAt',
        Sort: Orders.Descending,
      }
    };

    // Request
    return this.post<ILocalPageOutputDto<NotificationListDto[]>>('/tech/v2/notification/filter', true, filters, options)
  }

  getNotificationCount(): Observable<number> {
    return this.post<ILocalPageOutputDto<NotificationListDto[]>>('/tech/v2/notification/filter', true, [],
      {
        params: { pageSize: 1 },
        errorHandler: {} as CoreErrorHandlerBaseService // workaround for no error msg
      } as IRequestOptions
    ).pipe(
      map(output => output.paging.totalItems)
    );
  }

  markAllAsRead(): Observable<void> {
    return this.post('/tech/v2/notification/readAll', true);
  }

  getNotificationSettings(): Observable<ContactNotificationSettingsDto> {
    return this.get<ContactNotificationSettingsDto>('/tech/contact/me/notificationsetting', true);
  }

  setGlobalNotificationAllowance(isAllowed: boolean): Observable<ContactNotificationSettingsDto> {
    return this.post<ContactNotificationSettingsDto>('/tech/contact/me/notificationsetting/allowance', true, undefined, { params: { isAllowed } });
  }

  setNotificationAllowanceForSubject(subject: string, isAllowed: boolean): Observable<ContactNotificationSettingsDto> {
    return this.post<ContactNotificationSettingsDto>(`/tech/contact/me/notificationsetting/allowance/${ subject }`, true, undefined, { params: { isAllowed } });
  }
}
